module.exports = __webpack_public_path__ + "img/0-10.85571038.png";